export const handleModal = (type, show, data) => {
    return async (dispatch, getState) => {
        let initialState = {
            MAJOR_GUIDE: {
                show: false,
                data: {}
            },
            TESTS_GUIDE: {
                show: false,
                data: {}
            },
            WATCHED_FIRST_VIDEO: {
                show: false,
                data: {}
            },
            JUST_REGISTERED: {
                show: false,
                data: {}
            },
            FEEDBACK: {
                show: false,
                data: {}
            },
            JUST_ACTIVATED: {
                show: false,
                data: {}
            },
            JUST_CONFIRMED: {
                show: false,
                data: {}
            }
        }
        
        const handleDispatch = payload => dispatch({
            type: 'TOGGLE_MODALS',
            payload
        })

        if (type) {
            handleDispatch({
                ...initialState,
                [type]: {
                    show,
                    data
                }
            })
        } else {
            handleDispatch(initialState)
        }
    }
}